var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00017 1.70001C4.80242 1.70001 3.94335 2.85463 4.28752 4.00187L5.06915 6.6073L5.07576 6.62939C5.10404 6.72407 5.13077 6.81357 5.17459 6.89162C5.28577 7.08967 5.4759 7.23114 5.69755 7.28072C5.7849 7.30026 5.87831 7.30015 5.97712 7.30003L6.00017 7.30001L6.02323 7.30003C6.12203 7.30015 6.21544 7.30026 6.30279 7.28072C6.52444 7.23114 6.71457 7.08967 6.82576 6.89162C6.86957 6.81357 6.8963 6.72407 6.92458 6.62939L6.92459 6.62939L6.93119 6.6073L7.71282 4.00187C8.057 2.85463 7.19793 1.70001 6.00017 1.70001Z",
    fill: "#E72631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0002 8.20001C5.28223 8.20001 4.7002 8.78204 4.7002 9.50001C4.7002 10.218 5.28223 10.8 6.0002 10.8C6.71817 10.8 7.3002 10.218 7.3002 9.50001C7.3002 8.78204 6.71817 8.20001 6.0002 8.20001Z",
    fill: "#E72631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedIcon);
export default __webpack_public_path__ + "static/media/warning-red-icon.a012fab887396bb8f74894601561fb91.svg";
export { ForwardRef as ReactComponent };